import { UserResponse } from "../class/transferIntent";

export const clientUserDetailsResponse: UserResponse = {
  userId: "bridge-demo-user",
  clientUserId: "",
  created: "2024-06-30",
  email: "user@example.com",
  phoneNumber: "",
  firstName: "Jamie",
  middleName: "Lee",
  lastName: "Smith",
  suffix: "",
  citizenship: "",
  dateOfBirth: "",
  married: undefined,
  address: undefined,
};

export const fallbackProviderList: string[] = [
  "ADP, Inc.",
  "AIG Retirement Services",
  "Alerus Financial",
  "Alight",
  "Alliance Benefit Group",
  "American Funds/Capital Group",
  "Ameritas",
  "Ascensus",
  "Associated Bank",
  "Equitable",
  "Bank of America/Merrill Lynch",
  "BB&T/Truist",
  "Betterment",
  "BOK Financial",
  "BPAS (Benefit Plans Administrative Services)",
  "Capital Group",
  "Charles Schwab",
  "Conduent HR Services, LLC",
  "CUNA Mutual Retirement Solutions",
  "Employee Fiduciary",
  "Empower/Great West",
  "EPIC Retirement Plan Services",
  "Fidelity Investments",
  "Fifth Third Bank Retirement Service",
  "ForUsAll",
  "Guideline",
  "Human Interest",
  "Insperity",
  "Intrust Bank",
  "John Hancock",
  "JP Morgan",
  "Lincoln Financial Group",
  "Mass Mutual",
  "Merrill Edge",
  "MetLife",
  "Milliman",
  "Morgan Stanley",
  "Mutual of America",
  "Mutual of Omaha/Acensus",
  "Nationwide",
  "Newport Group",
  "One America/American United Life Insurance",
  "Paychex Retirement Services",
  "Pentegra Retirement Services",
  "Principal Financial Group",
  "PCS Retirement",
  "Prudential",
  "Securian Financial/Minnesota Life Insurance Company",
  "Sentinel Benefits & Financial Group",
  "Sentry Life Insurance Company",
  "Salvic Integrated Administration",
  "StanCorp Financial Group/The Standard",
  "SunTrust/Truist",
  "T. Rowe Price",
  "TIAA",
  "Transamerica",
  "Thrift Savings Plan",
  "Ubiquity Retirement",
  "USI Consulting Group",
  "Valic",
  "The Vanguard Group",
  "Vestwell",
  "Voya Financial",
  "Wells Fargo",
  "Merrill Edge",
  "TD Ameritrade",
  "ETRADE",
  "Firstrade",
  "Ally Invest",
  "Ellevest",
  "SoFi",
  "Interactive Brokers",
  "Fundrise",
  "Wealthfront",
  "Principal",
  "Ameriprice",
  "M1 Finance",
  "Acorns",
  "Wealthsimple",
  "USAA",
  "Alto",
  "Utah Retirement Systems",
];
